// extracted by mini-css-extract-plugin
export default {"container":"RadioSelect_container__YBvu9","labels":"RadioSelect_labels__U1T7F"};